
document.addEventListener('DOMContentLoaded', function(){
    function switchPanel(index){
        console.log('传入index=', index);
        const bodyWrap = document.querySelector('.body.page-support');
        const items = bodyWrap.querySelectorAll('.main_text_t .item');
        const maexNavList = bodyWrap.querySelectorAll('.main_menu .maex_nav');
        items.forEach(item=>item.style.display='none');
        const targetItem = bodyWrap.querySelector(`.main_text_t .item${index}`);
        if(targetItem){
            targetItem.style.display = 'block';
        }
        maexNavList.forEach(nav=>nav.classList.remove('active'));
        const targetNav = bodyWrap.querySelector(`.main_menu .maex_nav[data-panel="${index}"]`);
        if(targetNav){
            targetNav.classList.add('active');
            console.log('body内tab添加active成功：', targetNav.className);
        }
    }
    const verify_input = document.querySelector('.input_button .verify_input');
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const idStr = urlParams.get('id');
    if(code){
        switchPanel(1);
        if(verify_input) verify_input.value = code;
    }else if(idStr){
        const id = parseInt(idStr,10);
        if(!isNaN(id) && [1,2,3].includes(id)){
            switchPanel(id);
        }
    }
    const bodyWrap = document.querySelector('.body.page-support');
    bodyWrap.querySelector('.main_menu .mainex').addEventListener('click',function(e){
        // 增加：阻止一切潜在默认行为，兼容iconfont伪元素事件异常
        e.preventDefault();

        const navDom = e.target.closest('.maex_nav');
        if(!navDom) return;
        const panelNum = Number(navDom.dataset.panel);
        if(!isNaN(panelNum)){
            switchPanel(panelNum);

            // =========核心修复=========
            const searchParams = new URLSearchParams(window.location.search);
            const currentId = searchParams.get('id');
            // 如果点击的panel和url上id一模一样，完全不操作history，直接return
            if(String(panelNum) !== currentId){
                searchParams.set('id', panelNum);
                history.replaceState(null,'',`?${searchParams.toString()}`);
            }
        }
    });
});


const productVideoEl = document.querySelector('.verifyVideo');
const videoBoxEl = productVideoEl.querySelector('.video-box');
const videoEl = productVideoEl.querySelector('video');
const closeBtn = productVideoEl.querySelector('.close');
const playBtn = document.querySelector('.video_play');


// 点击播放按钮打开弹窗
playBtn.addEventListener('click',()=>{
  
  const src = "https://cdn.shopify.com/videos/c/o/v/838f927214ab4f00936332e02cad1b72.mp4";
  if(!src) return;
  videoEl.src = src;
  productVideoEl.classList.add('show');
  videoEl.play().catch(e=>{
    // 捕获浏览器自动播放拦截异常
    console.log("play reject:", e);
  });
});

// 关闭弹窗逻辑：暂停播放、清空src，释放资源
closeBtn.addEventListener('click',()=>{
  productVideoEl.classList.remove('show');
  videoEl.pause();
  videoEl.src = "";
  videoEl.load();
});

// 可选：点击遮罩层背景关闭弹窗
productVideoEl.addEventListener('click',(e)=>{
  if(e.target === productVideoEl){
    closeBtn.click();
  }
});

const MAX_ANGLE_X = 8;
const MAX_ANGLE_Y = 10;
const FOLLOW_SMOOTH = 0.22;
const RESET_TIME = 0.35;
const ROLL_DURATION = 0.4;     //翻滚到最大角度时长
const RECOVER_DURATION = 0.4; //平滑回退时长
function isPC() {
    return window.matchMedia('(min-width:769px)').matches;
}
document.addEventListener('DOMContentLoaded', () => {
    const cubeList = document.querySelectorAll('.faq_faq .faq_faq_row');
    // 收集所有dom实例，用于移动端互斥关闭
    const mobiItems = [];

    cubeList.forEach(cube => {
        let rollTween = null;
        let tiltTween = null;
        let isRollAnimating = false;
        let blockMouseMove = false;

        function runRoll(targetAngle) {
            if (rollTween) rollTween.kill();
            if (tiltTween) tiltTween.kill();
            isRollAnimating = true;
            rollTween = gsap.to(cube, {
                rotateX: targetAngle,
                duration: ROLL_DURATION,
                ease: "power2.inOut",
                onComplete: () => {
                    isRollAnimating = false;
                },
                onInterrupt: () => {
                    isRollAnimating = false;
                }
            });
        }

        // 给移动端用：复位当前卡片
        const closeMe = () => {
            cube.classList.remove('flipped');
            runRoll(0);
        };
        mobiItems.push({ el: cube, closeMe });

        if (isPC()) {
            cube.addEventListener('mouseenter', () => {
                blockMouseMove = false;
                if (rollTween) rollTween.kill();
                if (tiltTween) tiltTween.kill();
                isRollAnimating = false;
                cube.classList.add('flipped');
                runRoll(90); // ✅ 90 显示down底面
            });
            cube.addEventListener('mousemove', (e) => {
                if(blockMouseMove) return;
                if (isRollAnimating) return;
                if (cube.classList.contains('flipped')) return;
                const rect = cube.getBoundingClientRect();
                const xPercent = ((e.clientX - rect.left) / rect.width) - 0.5;
                const yPercent = ((e.clientY - rect.top) / rect.height) - 0.5;
                const targetRotateY = xPercent * MAX_ANGLE_Y;
                const targetRotateX = -yPercent * MAX_ANGLE_X;
                if (tiltTween) tiltTween.kill();
                tiltTween = gsap.to(cube, {
                    rotateX: targetRotateX,
                    rotateY: targetRotateY,
                    duration: FOLLOW_SMOOTH,
                    ease: "power1.out"
                });
            });
            cube.addEventListener('mouseleave', () => {
                blockMouseMove = true;
                if (rollTween) rollTween.kill();
                if (tiltTween) tiltTween.kill();
                isRollAnimating = false;
                cube.classList.remove('flipped');
                gsap.set(cube, { rotateY: 0 });
                runRoll(0);
                tiltTween = gsap.to(cube, {
                    rotateX: 0,
                    rotateY: 0,
                    duration: RESET_TIME,
                    ease: "power2.out"
                });
            });
        } else {
            let tapLock = false; // 防止touchstart+click重复执行

            function handleTap() {
                if(tapLock) return;
                if (isRollAnimating) return;

                tapLock = true;

                // 互斥逻辑：关闭其它打开的卡片
                mobiItems.forEach(item => {
                    if(item.el !== cube){
                        item.closeMe();
                    }
                });

                if (rollTween) rollTween.kill();
                if (tiltTween) tiltTween.kill();
                const flipped = cube.classList.toggle('flipped');
                if (flipped) {
                    runRoll(90);
                } else {
                    runRoll(0);
                }
                // 延时释放tap锁，避免短时间重复触发
                setTimeout(()=>{
                    tapLock = false;
                }, ROLL_DURATION * 1000 + 60);
            }

            // passive:true，不再 e.preventDefault()，不阻止页面滚动，靠tapLock去重
            cube.addEventListener('touchstart', handleTap, { passive:true });
            cube.addEventListener('click', handleTap);
        }
    });
});

